import { render, staticRenderFns } from "./AreaEmbargada.vue?vue&type=template&id=73b98ee9&scoped=true&lang=pug"
import script from "./AreaEmbargada.vue?vue&type=script&lang=js"
export * from "./AreaEmbargada.vue?vue&type=script&lang=js"
import style0 from "./AreaEmbargada.vue?vue&type=style&index=0&id=73b98ee9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b98ee9",
  null
  
)

export default component.exports